module.exports = __webpack_public_path__ + "static/media/origami18.fd078f41.JPG";